import {BenefitType} from './PlanBenefit'

export class Excess {

    constructor(
        public readonly id: string,
        public readonly amountInPence: number,
        public readonly benefitTypes: BenefitType[]
    ) {}

    public appliesTo?(givenBenefitType: BenefitType) {
        return this.benefitTypes.includes(givenBenefitType)
    }
}
